<template>
  <div class="electric-container">
    <el-card class="box-card"
             shadow="never">
      <i class="el-icon-tickets"></i>
      <span>客户电力交易结算</span>
      <el-button style="float: right; padding: 10px 20px"
                 class="btn-refresh el-icon-refresh">刷新</el-button>
    </el-card>
    <div style="margin-top:40px;">
      <el-form ref="form"
               :model="form"
               :inline="true"
               label-width="100px">
        <el-form-item label="企业：">
          <el-input class="input-width"
                    clearable
                    v-model="form.customername"
                    placeholder="请输入企业名称或关键字"></el-input>
        </el-form-item>
        <el-form-item label="区域：">
          <el-select v-model="form.regin"
                     clearable
                     placeholder="请选择区域">
            <el-option v-for="item in localized"
                       :key="item.id"
                       :label="item.region"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期：">
          <el-date-picker type="date"
                          placeholder="选择日期"
                          value-format="yyyy-MM-dd"
                          v-model="form.balancedate"
                          style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-button type="primary"
                   style="margin-left:50px;"
                   @click="electricInquire">查询</el-button>
      </el-form>
    </div>
    <div>
      <el-card class="box-card"
               shadow="never">
        <i class="el-icon-tickets"></i>
        <span>结算列表</span>
        <div class="btn-right">
          <!-- <p>
            单位：
            <span>万千瓦时、元</span>
          </p> -->
          <!-- <el-button type="primary">导入</el-button> -->
          <div class="clearfix">
            <el-upload :fileList="fileList"
                       action="https://jsonplaceholder.typicode.com/posts/"
                       :remove="handleRemove"
                       :beforeUpload="beforeUpload">
              <el-button>
                导入
              </el-button>
            </el-upload>
            <el-button type="primary"
                       @click="handleUpload"
                       :disabled="fileList.length === 0"
                       :loading="uploading"
                       style="margin-top: 16px">{{uploading ? 'Uploading' : 'Start Upload' }}</el-button>
          </div>
          <el-button type="primary"
                     @click="electricSetAdd">新增结算</el-button>
        </div>
      </el-card>
    </div>
    <el-table :data="tableData"
              border
              style="width: 100%">
      <el-table-column type="selection"
                       width="60"
                       align="center"></el-table-column>
      <el-table-column prop="balancedate"
                       label="结算日期"
                       width="120"
                       align="center"></el-table-column>
      <el-table-column prop="customername"
                       label="客户名称"
                       width="200"
                       align="center"></el-table-column>
      <el-table-column prop="areaName"
                       label="区域"
                       width="120"
                       align="center"></el-table-column>
      <el-table-column prop="electric"
                       label="交易电量(kW·h)"
                       width="120"
                       align="center"></el-table-column>
      <el-table-column prop="practical"
                       label="实际用电量(kW·h)"
                       width="120"
                       align="center"></el-table-column>
      <el-table-column prop="power"
                       label="偏差电量(kW·h)"
                       width="120"
                       align="center"></el-table-column>
      <el-table-column prop="deviationratio"
                       label="偏差率（%）"
                       width="120"
                       align="center"></el-table-column>
      <el-table-column prop="bias"
                       label="允许偏差电量(kWh)"
                       width="120"
                       align="center"></el-table-column>
      <el-table-column prop="assess"
                       label="考核执行偏差"
                       width="180"
                       align="center"></el-table-column>
      <el-table-column prop="deviation"
                       label="偏差考核费用"
                       width="180"
                       align="center"></el-table-column>
      <el-table-column prop="userfees"
                       label="用户考核偏差费用"
                       width="180"
                       align="center"></el-table-column>
      <el-table-column prop="companyexpense"
                       label="代理售电公司考核费用"
                       width="180"
                       align="center"></el-table-column>
      <el-table-column prop="discount"
                       label="优惠金额"
                       width="180"
                       align="center"></el-table-column>
      <el-table-column prop="totaldiscount"
                       label="合计优惠金额"
                       width="180"
                       align="center"></el-table-column>
      <el-table-column prop="remake"
                       label="备注"
                       width="180"
                       align="center"></el-table-column>
      <el-table-column float="right"
                       label="操作"
                       width="150"
                       align="center">
        <template slot-scope="scope">
          <el-button size="mini"
                     @click="electricSetEdit(scope.row)">编辑</el-button>
          <el-button size="mini"
                     @click="electricDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="electric-bottom">
      <!-- <el-checkbox v-model="checked">全选</el-checkbox>
      <el-select v-model="value" width="100" placeholder="批量操作">
        <el-option
          v-for="item in operateOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button class="search-button" type="primary">确定</el-button>-->
      <el-pagination background
                     @current-change="handleCurrentChange"
                     :page-size="pageSize"
                     layout="total,prev, pager, next,jumper"
                     :total="totalCount"></el-pagination>
    </div>
    <!-- 客户结算编辑弹出框 -->
    <!-- <el-dialog :visible.sync="centerDialogVisible" width="70%">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">客户电力交易结算</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a href="/">新增</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-form
        :rules="rules"
        :model="ruleForm"
        ref="ruleForm"
        label-width="160px"
        class="demo-ruleForm"
      >
        <el-form-item label="结算日期:" prop="date">
          <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.date"></el-date-picker>
        </el-form-item>
        <el-form-item label="客户名称:" prop="client">
          <el-input v-model="ruleForm.client"></el-input>
        </el-form-item>
        <el-form-item label="区域:" prop="area">
          <el-select v-model="form.area" placeholder="请选择区域">
            <el-option label="华北" value="shanghai"></el-option>
            <el-option label="冀中" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易电量:" prop="deal">
          <el-input v-model="ruleForm.deal">
            <template slot="deal"></template>
          </el-input>
        </el-form-item>
        <el-form-item label="实际用电量:" prop="practical">
          <el-input v-model="ruleForm.practical"></el-input>
        </el-form-item>
        <el-form-item label="偏差电量:" prop="deviation">
          <el-input v-model="ruleForm.deviation"></el-input>
        </el-form-item>
        <el-form-item label="偏差率:" prop="deviationRadio">
          <el-input v-model="ruleForm.deviationRadio"></el-input>
        </el-form-item>
        <el-form-item label="允许偏差电量:" prop="allow">
          <el-input v-model="ruleForm.allow"></el-input>
        </el-form-item>
        <el-form-item label="考核执行偏差:" prop="assess">
          <el-input v-model="ruleForm.assess"></el-input>
        </el-form-item>
        <el-form-item label="偏差考核费用:" prop="inspectionFee">
          <el-input v-model="ruleForm.inspectionFee"></el-input>
        </el-form-item>
        <el-form-item label="用户考核偏差费用:" prop="user">
          <el-input v-model="ruleForm.user"></el-input>
        </el-form-item>
        <el-form-item label="代理售电公司考核费用:" prop="power">
          <el-input v-model="ruleForm.power"></el-input>
        </el-form-item>
        <el-form-item label="优惠金额:" prop="favorable">
          <el-input v-model="ruleForm.favorable"></el-input>
        </el-form-item>
        <el-form-item label="合计优惠金额:" prop="total">
          <el-input v-model="ruleForm.total"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" v-model="ruleForm.remark"></el-input>
        </el-form-item>
        <el-form-item style="width:80%;">
          <el-button>取消</el-button>
          <el-button type="primary">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>-->
  </div>
</template>

<script>
export default {
  name: "electric",
  data () {
    return {

      fileList: [],   //上传数据表格
      uploading: false,  // 上传加载

      pageSize: 10, // 每页大小
      totalCount: 0, // 总数据量
      page: 1, // 当前页码
      localized: [], //遍历省份数组
      form: {
        customername: "",
        capital: "",
        balancedate: ""
      },
      tableData: [],

      checked: "false",
      value: "",
      operateOptions: [
        {
          label: "已申报",
          value: 2
        },
        {
          label: "申报中",
          value: 3
        },
        {
          label: "未开始",
          value: 4
        },
        {
          label: "批量删除",
          value: 1
        }
      ]
      // ruleForm: {
      //   date: "",
      //   client: "",
      //   area: "",
      //   deal: "",
      //   practical: "",
      //   deviation: "",
      //   deviationRadio: "",
      //   allow: "",
      //   assess: "",
      //   inspectionFee: "",
      //   user: "",
      //   power: "",
      //   favorable: "",
      //   total: "",
      //   remark: ""
      // },
      // rules: {
      //   date: [{ required: true, message: "请输入结算日期", trigger: "blur" }],
      //   client: [
      //     { required: true, message: "请输入客户名称", trigger: "blur" }
      //   ],
      //   area: [{ required: true, message: "请输入所在区域", trigger: "blur" }]
      // }
    };
  },
  created () {
    this.electricLoader();
  },
  mounted () {
    //省份查询
    this.provinceQuery();
  },
  methods: {

    // 上传文件
    handleRemove (file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload (file) {
      this.fileList = [...this.fileList, file];
      return false;
    },
    handleUpload () {
      const { fileList } = this;
      const formData = new FormData();
      fileList.forEach(file => {
        formData.append('file', file);
      });
      this.uploading = true;

      // You can use any AJAX library you like
      this.$http({
        url: '/Client/fileUpload',
        method: 'post',
        processData: false,
        data: formData,
        success: () => {
          this.fileList = [];
          this.uploading = false;
          this.$message.success('upload successfully.');
        },
        error: () => {
          this.uploading = false;
          this.$message.error('upload failed.');
        },
      });
    },

    //调取后端省份接口
    provinceQuery: function () {
      const data = {};
      this.$http({
        method: "post",
        url: "/Client/Linkage"
      }).then(res => {
        this.localized = res.data;
      });
    },
    //加载页面
    electricLoader () {
      this.$http({
        method: "POST",
        url: "/Deal/Query",
        data: {
          page: this.page, //页面
          size: this.pageSize // 每页大小
          // customername: this.tableData.customername,
          // capital: this.tableData.capital,
          // datetime: this.tableData.datetime,
        }
      }).then(res => {
        this.tableData = res.data.data;
        this.totalCount = res.data.total;
        // this.dateTime = Number(this.tableData.balancedate)
        // console.log(this.dateTime)
      });
    },
    // 分页
    handleCurrentChange (page) {
      // 将数据中的页码修改为当前最新改变的数据页码
      this.page = page;
      // 页码改变，重新加载当前文章列表
      this.electricLoader();
    },
    // 文章检索
    loadchannels () {
      this.$http({
        method: "POST",
        url: "/Deal/Query",
        data: {
          page: this.page, //页面
          size: this.pageSize, // 每页大小
          customername: this.form.customername,
          capital: this.form.regin,
          datetime: this.form.balancedate
        }
      }).then(res => {
        this.tableData = res.data.data;
        this.totalCount = res.data.total;
      });
    },
    // 检索
    electricInquire () {
      // 点击查询按钮，根据表单中的数据查询文章列表
      this.page = 1; // 查询从第1页开始加载数据
      this.loadchannels();
    },
    // 添加
    electricSetAdd () {
      this.$router.push({
        path: "../electricAdd",
      });
    },
    //编辑
    electricSetEdit (item) {
      this.$router.push({
        path: "../electricEdit",
        query: { id: item.id }
      });
    },
    //删除
    electricDelete (item) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(item.id);
          this.$http.get("/Deal/Delete", {
            params: {
              id: item.id
            }
          });
          this.$message({
            type: "success",
            message: "删除成功"
          });
          //删除成功重新加载数据列表
          this.loadArticles();
        })
        .catch(err => {
          if (err === "cannel") {
            return this.$message({
              type: "info",
              message: "已取消删除"
            });
          }
          // this.$message.error("删除失败");
        });
    }
  }
};
</script>

<style lang='less' scoped>
.btn-right {
  float: right;
}
.electric-bottom {
  margin-top: 30px;
}
.el-pagination {
  float: right;
}
.el-select {
  margin: 0 15px;
}
.el-form {
  margin: 30px 30px;
}
.el-form-item {
  display: inline-block;
  margin-left: 20px;
}
</style>
